module.exports = __webpack_public_path__ + "img/instagram-dark-icon.3536d8d7.svg";